import {TransactionAction, TransactionsActions} from '../actions/transactions.actions';
import {TransactionFailReasonState} from '../state/transaction-fail-reason.state';
import {WithdrawAction} from '../models/action.model';

export const initialFailReasonState: TransactionFailReasonState = {
    '': ''
};

export function transactionFailReasonReducer(
    state: TransactionFailReasonState = initialFailReasonState,
    action: TransactionAction
) {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const actionsWithFailReason: WithdrawAction[] = action.actions.filter(a => a.metadata?.failReason);
            const lastAction: WithdrawAction = actionsWithFailReason.length > 0 ? actionsWithFailReason[actionsWithFailReason.length - 1] : null;
            return {
                ...state,
                [action.transactionId]: lastAction ? lastAction.metadata?.failReason : null,
            };
    }
}
